export const changeFavicon = (theme) => {
  const faviconImage = {
    light: "favicon-light.ico",
    dark: "favicon-dark.ico",
  };
  const favicon = document.getElementById("favicon");

  favicon.href = `/${faviconImage[theme]}`;
};
